import { render } from "./AppleHeader.vue?vue&type=template&id=313fc8dc&scoped=true&lang=true"
import script from "./AppleHeader.vue?vue&type=script&lang=js"
export * from "./AppleHeader.vue?vue&type=script&lang=js"

import "./AppleHeader.vue?vue&type=style&index=0&id=313fc8dc&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-313fc8dc"]])

export default __exports__